var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (data) {pug_mixins["renderList"] = pug_interp = function(listOfLinks, isRoot){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cul class=\"rlist\"\u003E";
// iterate listOfLinks
;(function(){
  var $$obj = listOfLinks;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes(["side-menu__nav-menu__list-item",`${isRoot?'side-menu__nav-menu__list-item--root':''}`], [false,true]), false, true)) + "\u003E";
if ((isRoot && index === 3)) {
pug_html = pug_html + "\u003Ca class=\"side-menu__nav-menu__link\" href=\"#slider-side-menu-topicsNav\" data-slider=\"side-menu\" data-action=\"navigate\" data-screen=\"screen-topicsNav\"\u003ETopics \u003Ci class=\"icon-arrow-right\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
else {
if ((item.title)) {
pug_html = pug_html + "\u003Ch6 class=\"side-menu__nav-menu__title\"\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fh6\u003E";
pug_mixins["renderList"](item.children);
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"side-menu__nav-menu__link\""+pug.attr("href", item.link, true, true)) + "\u003E" + (null == (pug_interp = item.text) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes(["side-menu__nav-menu__list-item",`${isRoot?'side-menu__nav-menu__list-item--root':''}`], [false,true]), false, true)) + "\u003E";
if ((isRoot && index === 3)) {
pug_html = pug_html + "\u003Ca class=\"side-menu__nav-menu__link\" href=\"#slider-side-menu-topicsNav\" data-slider=\"side-menu\" data-action=\"navigate\" data-screen=\"screen-topicsNav\"\u003ETopics \u003Ci class=\"icon-arrow-right\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
else {
if ((item.title)) {
pug_html = pug_html + "\u003Ch6 class=\"side-menu__nav-menu__title\"\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fh6\u003E";
pug_mixins["renderList"](item.children);
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"side-menu__nav-menu__link\""+pug.attr("href", item.link, true, true)) + "\u003E" + (null == (pug_interp = item.text) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
};
pug_html = pug_html + "\u003Cnav class=\"text-uppercase\"\u003E";
data.splice(3, 0, {}) // topic nav
pug_mixins["renderList"](data, true);
pug_html = pug_html + "\u003C\u002Fnav\u003E";}.call(this,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined));;return pug_html;};
module.exports = template;